module.exports = __webpack_public_path__ + "img/horizontal_3_2_7042.fe521193.png";